<template>
  <v-container fluid>
    <v-row>
      <card headline="ข้อมูลอาจารย์ใหญ่" :records="records.info"></card>
      <card headline="การติดต่อ" :records="records.contact"></card>
      <card headline="ที่อยู่" :records="records.address"></card>
      <card headline="ครอบครัว" :records="records.family"></card>
      <card headline="พิธีการ" :records="records.ceremony"></card>
      <card headline="วัดย่อย (อัพเดท COVID-19 แล้ว)" :records="records.temple"></card>
      <assetCard></assetCard>
    </v-row>
  </v-container>
</template>

<script>
/// <reference path="../../../types/cadavers.d.ts" />

import card from "./card";
import assetCard from "./assetCard";

export default {
  name: "cadaver",
  components: { card, assetCard },
  props: ["cadaver"],
  computed: {
    records() {
      /** @type {Cadaver} */
      const cadaver = this.cadaver;
      const address = cadaver.address;
      return {
        info: [
          {
            label: "เลข P",
            value: cadaver.number
          },
          {
            label: "ชื่ออาจารย์ใหญ่",
            value: cadaver.title + cadaver.name + " " + cadaver.surname
          },
          {
            label: "ญาติ",
            value:
              cadaver.relative.title +
              cadaver.relative.name +
              " " +
              cadaver.relative.surname +
              " (" +
              (cadaver.relative.type || "-") +
              ")"
          }
        ],
        contact: [
          {
            label: "ช่องทางหลัก",
            value: cadaver.mainContact
          },
          {
            label: "โทรศัพท์",
            value: cadaver.tels
              .map(tel => `${tel.tel} (${tel.name || "-"})`)
              .join(", ")
          },
          {
            label: "Email",
            value: cadaver.email
          }
        ],
        address: [
          {
            label: "ห้อง",
            value: address.room
          },
          {
            label: "บ้านเลขที่",
            value: address.number
          },
          {
            label: "อาคาร/หมู่บ้าน",
            value: address.building
          },
          {
            label: "หมู่",
            value: address.village
          },
          {
            label: "ซอย/ตรอก",
            value: address.lane
          },
          {
            label: "ถนน",
            value: address.road
          },
          {
            label: "แขวง/ตำบล",
            value: address.subdistrict
          },
          {
            label: "เขต/อำเภอ",
            value: address.district
          },
          {
            label: "จังหวัด",
            value: address.province
          },
          {
            label: "รหัสไปรษณีย์",
            value: address.code
          }
        ],
        family: [
          {
            label: "คำอ่านออกเสียง",
            value: cadaver.pronunciation
          },
          {
            label: "บิดา",
            value: cadaver.father
              ? cadaver.father.title +
                cadaver.father.name +
                " " +
                cadaver.father.surname
              : "-"
          },
          {
            label: "มารดา",
            value: cadaver.mother
              ? cadaver.mother.title +
                cadaver.mother.name +
                " " +
                cadaver.mother.surname
              : "-"
          },
          {
            label: "พี่น้อง",
            value: cadaver.siblings
              ? cadaver.siblings
                  .map(
                    sibling =>
                      `${sibling.title}${sibling.name} ${sibling.surname}`
                  )
                  .join(", ")
              : "-"
          },
          {
            label: "คู่สมรส",
            value: cadaver.spouse
              ? cadaver.spouse.title +
                cadaver.spouse.name +
                " " +
                cadaver.spouse.surname
              : "-"
          },
          {
            label: "บุตร",
            value: cadaver.children
              ? cadaver.children
                  .map(child => `${child.title}${child.name} ${child.surname}`)
                  .join(", ")
              : "-"
          }
        ],
        ceremony: [
          {
            label: "การจัดการร่าง",
            value: cadaver.ceremony
              ? cadaver.ceremony.ash
                ? {
                    All:
                      "ญาติมอบให้ภาควิชากายวิภาคศาสตร์ฌาปนกิจ ญาติประสงค์เก็บอัฐิและอังคารไปทั้งหมด",
                    Partial:
                      "ญาติมอบให้ภาควิชากายวิภาคศาสตร์ฌาปนกิจ ญาติประสงค์เก็บอัฐิไว้ส่วนหนึ่ง และมอบส่วนที่เหลือให้ภาควิชากายวิภาคศาสตร์ดำเนินการลอยอังคาร",
                    None:
                      "ญาติมอบให้ภาควิชากายวิภาคศาสตร์ฌาปนกิจ ญาติไม่ประสงค์เก็บอัฐิและอังคาร โดยทางภาควิชากายวิภาคศาสตร์จะนำไปลอยอังคารทั้งหมด"
                  }[cadaver.ceremony.ash]
                : "ญาติประสงค์ขอรับร่างท่านอาจารย์ใหญ่ไปดำเนินพิธีทางศาสนาด้วยตัวเอง"
              : "-"
          },
          {
            label: "รับอัฐิก่อนวันที่ 1 มิ.ย.",
            value: cadaver?.ceremony?.earlyAsh ?? "-"
          },
          {
            label: "ขอไฟพระราชทาน",
            value: cadaver?.ceremony?.fire ?? "-"
          },
          {
            label: "ใบประกาศเกียรติคุณ",
            value:
              cadaver.ceremony && cadaver.ceremony.certificate
                ? `${cadaver.ceremony.certificate.title}${cadaver.ceremony.certificate.name} ${cadaver.ceremony.certificate.surname} (${cadaver.ceremony.certificate.tel})`
                : "-"
          },
          {
            label: "หนังสืออนุสรณ์",
            value: cadaver.ceremony ? cadaver.ceremony.book : "-"
          },
          {
            label: "CD",
            value: cadaver.ceremony ? cadaver.ceremony.cd : "-"
          },
          {
            label: "จำนวนผู้ร่วมงานวันที่ 12 ธ.ค.",
            value: cadaver?.ceremony?.dec12Guest?.all ?? "-"
          },
          {
            label: "จำนวนผู้ร่วมงานที่ใช้รถเข็นวันที่ 12 ธ.ค.",
            value: cadaver?.ceremony?.dec12Guest?.wheelchair ?? "-"
          },
          {
            label: "จำนวนผู้ร่วมงานที่เป็นพระภิกษุวันที่ 12 ธ.ค.",
            value: cadaver?.ceremony?.dec12Guest?.monk ?? "-"
          },
          {
            label: "จำนวนผู้ร่วมงานวันที่ 13 ธ.ค.",
            value: cadaver?.ceremony?.dec13Guest?.all ?? "-"
          },
          {
            label: "จำนวนผู้ร่วมงานที่ใช้รถเข็นวันที่ 13 ธ.ค.",
            value: cadaver?.ceremony?.dec13Guest?.wheelchair ?? "-"
          },
          {
            label: "จำนวนผู้ร่วมงานที่เป็นพระภิกษุวันที่ 13 ธ.ค.",
            value: cadaver?.ceremony?.dec13Guest?.monk ?? "-"
          },
        ],
        temple: [
          {
            label: "ยืนยันการเผาวัดย่อย หลังเลื่อนงาน",
            value: cadaver?.meta?.covidPostponed ?? "-"
          },
          {
            label: "วัดย่อย",
            value: cadaver?.temple?.name ?? "-"
          },
          {
            label: "วันที่",
            value: cadaver?.temple?.date ?? "-"
          },
          {
            label: "เวลา",
            value: cadaver?.temple?.time ?? "-"
          },
          {
            label: "จำนวนผู้ร่วมงาน",
            value: cadaver?.temple?.guest ?? "-"
          }
        ]
      };
    }
  }
};
</script>
